import { getBalances, GetBalancesParams, GetBalancesResponse } from '@ar/network/AccountsReceivable.network';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export const FETCH_BALANCES_QUERY_KEY = 'FETCH_BALANCES_QUERY_KEY';

type UseGetBalancesOptions = {
    enabled?: boolean,
};

export const useGetBalances = (params: GetBalancesParams, options?: UseGetBalancesOptions): UseQueryResult<GetBalancesResponse> => useQuery(
    [FETCH_BALANCES_QUERY_KEY, params],
    async () => getBalances(params),
    {
        enabled: (Boolean(params.supplier_id) || Boolean(params.gpo_id)) && (options?.enabled ?? true),
        refetchOnWindowFocus: false,
        retry: 3,
        staleTime: Infinity,
    },
);
